import { createTheme } from '@material-ui/core/styles'
import themes, { extendTheme } from 'themes'

export const JRL_NAV_ACTIVE_BG = '#CBEAFF'

export const isJrlProgramNavPath = pathname => {
  if (!/\/locations\/[^/]+\//.test(pathname)) {
    return false
  }

  if (/\/programs\/new(?:\/|$)/.test(pathname)) {
    return false
  }

  return /\/(?:programs|championship-season|regional-championship-program|national-championship-program)\/[^/]+/.test(
    pathname,
  )
}

export const isJrlLocationsNavSelected = ({ path, location }) =>
  location.pathname.startsWith(path) && !isJrlProgramNavPath(location.pathname)

const jrlNavigationOverrides = {
  MuiDrawer: {
    paper: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  MuiListItemIcon: {
    root: {
      color: 'rgba(0, 0, 0, 0.87)',
      minWidth: '2.25rem',
    },
  },
}

export const createJrlNavigationTheme = () =>
  extendTheme({
    palette: {
      sidebar: {
        ...themes.common.palette.sidebar,
        activeBg: JRL_NAV_ACTIVE_BG,
      },
    },
    overrides: jrlNavigationOverrides,
  })(extendTheme(themes.juniorLeague)(createTheme(themes.common)))
